// extracted by mini-css-extract-plugin
export default {"dialogContent":"style--dialogContent--66d96a"};